import 'core-js/stable'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import axios from './utils/axios'
import VueSweetalert2 from 'vue-sweetalert2'
import Vuelidate from 'vuelidate'
import i18n from './lang'
import store from './vuex'

Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.use(VueSweetalert2)
Vue.use(Vuelidate)
Vue.use(BootstrapVue)

Vue.prototype.axios = axios
Vue.prototype.$log = console.log.bind(console)

new Vue({
  el: '#app',
  axios,
  router,
  store,
  i18n,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
